import * as actions from '../../utils/Actions';

const initialState = {
    allInstitutes: [],
    showPageLoader: false,
    instituteDetails:null,
    otpDetails:null,
    otpVerificationDetails:null,
    payzAppBannerData:[],
    isCaptchaRejected: false,
    termCondtionStatus:null,
    otpVerificationUnregistered:null,
    getAllSuperEnitity:null,
    superEntityConfig:null
}

export default function institute(state = initialState, action) {

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type) {


        case actions.RESET_INSTITUTE_DATA:
            return {
                ...state,
                instituteDetails:null,
                otpDetails:null,
                otpVerificationUnregistered:null
            }

        case actions.RESET_OTP_DATA:
            return {
                ...state,
                otpDetails:null,
                otpVerificationDetails:null
            }
    
        case actions.pending(actions.GET_ALL_INSTITUTES):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_ALL_INSTITUTES):
            return {
                ...state,
                allInstitutes: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.GET_ALL_INSTITUTES):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.GET_INSTITUTE_CONFIGURATION):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.GET_INSTITUTE_CONFIGURATION):
            return {
                ...state,
                instituteDetails: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.GET_INSTITUTE_CONFIGURATION):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.SEND_OTP):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.SEND_OTP):
            return {
                ...state,
                otpDetails: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.SEND_OTP):
            return {
                ...state,
                showPageLoader: false
            }
            
            
        case actions.pending(actions.OTP_VERIFICATION):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.OTP_VERIFICATION):
            return {
                ...state,
                otpVerificationDetails: action.payload.data,
                showPageLoader: false,
                isCaptchaRejected: false

            }

        case actions.rejected(actions.OTP_VERIFICATION):
            return {
                ...state,
                showPageLoader: false,
                isCaptchaRejected: true
            }

            case actions.pending(actions.GET_PAYZAPP_BANNER):
                return {
                    ...state,
                    showPageLoader: true
                }
    
            case actions.fulfilled(actions.GET_PAYZAPP_BANNER):
                return {
                    ...state,
                    payzAppBannerData: action.payload.data,
                    showPageLoader: false
                }
    
            case actions.rejected(actions.GET_PAYZAPP_BANNER):
                return {
                    ...state,
                    showPageLoader: false
                }
        

            case actions.pending(actions.UPDATE_TERM_AND_CONDITIONS):
                return {
                    ...state,
                    showPageLoader : false
                }
        
            case actions.fulfilled(actions.UPDATE_TERM_AND_CONDITIONS):
                
                return {
                    ...state,
                    termCondtionStatus :  action.payload.data,
                    showPageLoader : false
                }
        
            case actions.rejected(actions.UPDATE_TERM_AND_CONDITIONS):
                
                return {
                    ...state,
                    showPageLoader : false
                }

            case actions.pending(actions.OTP_VERIFICATION_UNREGISTERED):
                return {
                    ...state,
                    showPageLoader : false
                }
        
            case actions.fulfilled(actions.OTP_VERIFICATION_UNREGISTERED):
                
                return {
                    ...state,
                    otpVerificationUnregistered :  action.payload.data,
                    showPageLoader : false
                }
        
            case actions.rejected(actions.OTP_VERIFICATION_UNREGISTERED):
                
                return {
                    ...state,
                    showPageLoader : false
                }

            case actions.pending(actions.GET_ALL_SUPER_ENTITIES):
                return {
                    ...state,
                    showPageLoader : false
                }
        
            case actions.fulfilled(actions.GET_ALL_SUPER_ENTITIES):
                
                return {
                    ...state,
                    getAllSuperEnitity :  action.payload.data,
                    showPageLoader : false
                }
        
            case actions.rejected(actions.GET_ALL_SUPER_ENTITIES):
                
                return {
                    ...state,
                    showPageLoader : false
                }

            case actions.pending(actions.GET_SUPER_ENTITY_CONFIG):
                return {
                    ...state,
                    showPageLoader : false
                }
        
            case actions.fulfilled(actions.GET_SUPER_ENTITY_CONFIG):
                
                return {
                    ...state,
                    superEntityConfig :  action.payload.data,
                    showPageLoader : false
                }
        
            case actions.rejected(actions.GET_SUPER_ENTITY_CONFIG):
                
                return {
                    ...state,
                    showPageLoader : false
                }


                
        default:
            return { ...state }
    }

}
